export function useIsAboutBookPath() {
  const route = useRoute()
  return computed(() => route.hash === '#om-boken')
}
